// src/api/axios.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://www.nizamhr.com/backend/api/hr/v1/landing/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error?.response?.data || error);
    return Promise.reject(error);
  }
);

export default api;